// Paths
export const CONTAINER_HOME_LOADING_ID = 'container/home/loading';
export const CONTAINER_HOME_ID = 'container/home';
export const CONTAINER_BLOG_ID = 'container/blog';
export const CONTAINER_ADMIN_HOME_ID = 'container/admin/home';
export const ADMIN_HOME_ID = 'admin/home';
